import {Stack, Typography, useTheme} from '@mui/material';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React from 'react';

const {wellcome, description} =
	translations['pt-br'].privateFlow.myHospitalization.generalOrientations;

export const HeaderGeneralOrientationsHospitalization = () => {
	const {colors} = useTheme();
	const {isTablet} = useMediaQueries();
	return (
		<Stack>
			<Typography variant={isTablet ? 'h6' : 'h5'}>{wellcome}</Typography>
			<Typography variant="body1" color={colors.light.text.primary}>
				{description.line1}
			</Typography>
			<Typography variant="body1" color={colors.light.text.primary}>
				{description.line2}
			</Typography>
		</Stack>
	);
};
